import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { createApiUrl } from '../utils/apiConfig';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();
  const [message, setMessage] = useState('Processing Payment...');

  useEffect(() => {
    const processPayment = async () => {
      try {
        const sessionId = searchParams.get('session_id');
        
        if (!sessionId) {
          console.error('No session ID found in URL');
          setMessage('Payment processing failed - no session ID found');
          setTimeout(() => navigate('/dashboard'), 3000);
          return;
        }

        // Make API call to backend to process the payment
        const _response = await axios.get(createApiUrl(`/api/payment-success?session_id=${sessionId}`), {
          withCredentials: true
        });
        
        setMessage('Payment successful! Redirecting to your dashboard...');
        
        // Redirect after successful processing
        setTimeout(() => {
          if (user?.isSchAdmin) {
            navigate('/school-admin-dashboard');
          } else if (user?.isOrgAdmin) {
            navigate('/org-admin-dashboard');
          } else {
            navigate('/dashboard');
          }
        }, 2000);
        
      } catch (error) {
        console.error('Error processing payment:', error);
        setMessage('Payment processing failed. Redirecting to dashboard...');
        setTimeout(() => navigate('/dashboard'), 3000);
      }
    };

    processPayment();
  }, [navigate, user, searchParams]);

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body text-center">
              <h2 className="card-title">{message}</h2>
              <p className="card-text">Please wait while we process your payment.</p>
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
